import { NgClass } from '@angular/common';
import { Component, ViewEncapsulation, input } from '@angular/core';

import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';
import { EmailTextComponent } from '../email-text/email-text.component';

@Component({
  selector: 'email-codebox',
  styleUrls: ['./email-codebox.component.less'],
  template: `
    <span
      [ngClass]="{
        codebox: true,
        'codebox-inline': inline(),
        'codebox-block': !inline(),
        'codebox-full-width': fullWidth(),
      }"
    >
      <table class="codebox-table" cellspacing="0" cellpadding="0">
        <tr>
          <td class="codebox-content">
            <email-text [contents]="code()" [className]="'codebox-text'" />
          </td>
        </tr>
      </table>
    </span>
  `,
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
  imports: [EmailTextComponent, NgClass],
})
export class EmailCodeBoxComponent {
  public readonly theme = input<'default' | 'tellent'>('default');
  public readonly code = input<WrappedValue<string>>(undefined!);
  public readonly inline = input<boolean>(false);
  public readonly fullWidth = input<boolean>(false);
}
